(function () {
    $(document).ready(function () {
        const toggleBtn = document.querySelector('.toggle-button');
        const navEl     = document.getElementById('footer-linksection-strato_group-nav');

        if (toggleBtn) {
            toggleBtn.addEventListener('click', function() {
                const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
                toggleBtn.setAttribute('aria-expanded', !isExpanded);
            });
        }
    });
}());
